import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {HttpClient} from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class CollecttotalindiandataService {
  url: string = 'https://api.covidindiatracker.com/total.json';
  constructor(public http: HttpClient) { }
  getData(): Observable <any>{

    return this.http.get(this.url);
  }
}
